import { theme as baseTheme, primaryColor } from 'smooth-doc/src/theme';

export const theme = {
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
        ...primaryColor('green'),

        // Language selector colors
        languageSelectorBg: '#f4f4f4',
        languageSelectorChevron: '#000000',

        modes: {
            ...baseTheme.colors?.modes,
            dark: {
                ...baseTheme.colors?.modes?.dark,
                languageSelectorBg: '#2a2a2a', // lighter dark tone
                languageSelectorChevron: '#e0e0e0' // light gray chevrons for dark mode
            }
        }
    }
};

